/** 仅在点击复制时写入剪贴板，不读取剪贴板，也不记录复制的编号。 */
export async function copyText(text) {
  const value = String(text);
  if (
    typeof navigator !== "undefined" &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch (error) {
      // 原生接口可能因 HTTP 页面或权限限制失败，继续尝试旧浏览器复制方式。
    }
  }

  if (typeof document === "undefined" || !document.body)
    throw new Error("Clipboard unavailable");
  const activeElement = document.activeElement;
  const selection = document.getSelection && document.getSelection();
  const ranges = [];
  if (selection) {
    for (let index = 0; index < selection.rangeCount; index++)
      ranges.push(selection.getRangeAt(index).cloneRange());
  }
  const input = document.createElement("textarea");
  input.value = value;
  input.setAttribute("readonly", "");
  input.style.position = "fixed";
  input.style.left = "-9999px";
  input.style.top = "0";
  document.body.appendChild(input);
  try {
    input.focus();
    input.select();
    if (!document.execCommand || document.execCommand("copy") !== true)
      throw new Error("Copy rejected");
  } finally {
    // 只移除本次临时 DOM 节点，并恢复原来的焦点和选区，不留下隐藏编号。
    document.body.removeChild(input);
    if (activeElement && typeof activeElement.focus === "function")
      activeElement.focus();
    if (selection) {
      selection.removeAllRanges();
      ranges.forEach((range) => selection.addRange(range));
    }
  }
}
